import { LogoPropsType } from './logoTypes';

export default function PythonLogo({ monochrome, className }: LogoPropsType) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <g clipPath="url(#clip0_7846_10649)">
        <path
          d="M15.8095 0.000261741C14.49 0.00632582 13.2299 0.117631 12.1211 0.31168C8.8549 0.882413 8.26188 2.07701 8.26188 4.28004V7.18958H15.9804V8.15942H5.36518C3.12197 8.15942 1.15775 9.493 0.543364 12.0299C-0.165319 14.9378 -0.196753 16.7524 0.543364 19.7887C1.09202 22.0488 2.4023 23.6592 4.64551 23.6592H7.29931V20.1713C7.29931 17.6515 9.50357 15.4288 12.1211 15.4288H19.8306C21.9767 15.4288 23.6899 13.6811 23.6899 11.5494V4.28004C23.6899 2.21113 21.9253 0.656973 19.8306 0.31168C18.5047 0.093374 17.129 -0.00580243 15.8095 0.000261741ZM11.6354 2.34035C12.4326 2.34035 13.0837 2.99483 13.0837 3.79957C13.0837 4.60145 12.4326 5.24989 11.6354 5.24989C10.8352 5.24989 10.187 4.60145 10.187 3.79957C10.187 2.99483 10.8352 2.34035 11.6354 2.34035Z"
          fill={monochrome ? 'currentColor' : 'url(#paint0_linear_7846_10649)'}
        />
        <path
          d="M24.6525 8.15942V11.5494C24.6525 14.1777 22.3996 16.3898 19.8306 16.3898H12.1211C10.0094 16.3898 8.26188 18.1774 8.26188 20.2691V27.5385C8.26188 29.6075 10.0808 30.8244 12.1211 31.4179C14.5644 32.1285 16.9073 32.2569 19.8306 31.4179C21.7738 30.8615 23.6899 29.7416 23.6899 27.5385V24.629H15.9804V23.6592H27.5492C29.7924 23.6592 30.6283 22.1116 31.4084 19.7887C32.2142 17.3973 32.18 15.0976 31.4084 12.0299C30.854 9.82117 29.7952 8.15942 27.5492 8.15942H24.6525ZM20.3164 26.5687C21.1166 26.5687 21.7648 27.2171 21.7648 28.019C21.7648 28.8238 21.1166 29.4782 20.3164 29.4782C19.5192 29.4782 18.8681 28.8238 18.8681 28.019C18.8681 27.2171 19.5192 26.5687 20.3164 26.5687Z"
          fill={monochrome ? 'currentColor' : 'url(#paint1_linear_7846_10649)'}
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_7846_10649"
          x1="-1.29887e-07"
          y1="-1.11742e-07"
          x2="23.8452"
          y2="20.5171"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A9FD4" />
          <stop offset="1" stopColor="#306998" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7846_10649"
          x1="20.131"
          y1="27.7744"
          x2="13.8384"
          y2="18.8591"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD43B" />
          <stop offset="1" stopColor="#FFE873" />
        </linearGradient>
        <clipPath id="clip0_7846_10649">
          <rect width="32" height="32" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
